import { EntityLookupModel } from '@models/entity-lookup.model';
import { createAction, props } from '@ngrx/store';
import { LocationModel } from 'src/app/locations/location.model';

export const SetEntityLookup = createAction(
  '[Entity Lookup] Set Entity Lookup',
  props<{ payload: EntityLookupModel.EntityLookupDocument[] }>(),
);

export const FlattenEntityLookup = createAction(
  '[EntityLookup] Flatten Entity Lookup',
  props<{ locations: LocationModel.LocationItem[] }>()
);

export const FlattenEntityLookupFail = createAction(
  '[EntityLookup] Flatten Entity Lookup Fail',
  props<{ error: any }>()
);
